<template>
    <div class="parrow_box">
      <v-card-text>
      <!-- <h5 class="accent--text" style="font-size: 12px; font-weight:700"> Settled Growers(Non checkoff) </h5> -->
      <v-layout>
                <v-flex xs3>
                  <span class="accent--text" style="font-size: 14px; font-weight:700;"> Settled Growers(Non checkoff)</span>
                </v-flex>
                <v-spacer>
                </v-spacer>


                <v-flex xs3>
                  <v-text-field
                v-model="search"
                label="Search "
                @input="handleSearchInput"
                class="search-input"
                style="max-width: 300px; margin: 0; padding: 0"
              ></v-text-field>
                </v-flex>

              </v-layout>
      <table class="table">
        <thead class="thead">
          <tr>
            <th scope="col">Grower Code</th>
            <th scope="col">Eslip Number</th>
            <th scope="col">Eslip Amount</th>
            <th scope="col">Grower Amount</th>
            <th scope="col">Invoice Amount</th>
            <th scope="col">Invoice Number</th>
            <th scope="col">Status</th>
            <th scope="col">Date Settled</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="file in paginatedFiles" v-bind:key="file.id">
            <td>{{ file.growerCode }}</td>
            <td>{{ file.eslipNumber }}</td>
            <td>{{ file.eslipAmount }}</td>
            <td>{{ file.amount }}</td>
            <td>{{ file.invoiceAmount }}</td>
            <td>{{ file.invoiceId }}</td>
            <td>{{ file.status.statusName }}</td>
            <td>{{ file.datePaid | prettyDate }}</td>
            <td class="actions">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                   <v-btn
                    color="primary"
                    v-on="on"
                    text
                    icon

                  >
                    <v-icon small> more_horiz </v-icon>
                  </v-btn>
                  </template>
                  <v-list>
                      <v-list-item v-if="canBeApproved(file)" @click="approveAction(file)">
                        <v-list-item-title> Approve </v-list-item-title>
                      </v-list-item>

                      <v-list-item  v-bind:to="'/unbulking/getallbyunbulkedid/'+file.id">
                        <v-list-item-title> View </v-list-item-title>
                      </v-list-item>
                    </v-list>

                </v-menu>
              </td>
          </tr>
        </tbody>
      </table>
      </v-card-text>
      <v-card-actions>
        <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
        <v-spacer></v-spacer>
        <v-pagination
        v-model="page"
        :length="numberOfLinks"
        :total-visible="7"
        color="secondary"
                class="accent--text logoutbtn"
      ></v-pagination>
      </v-card-actions>
    </div>
    </template>
    <script>
    // import { files } from '../../util/sampledata'
    import axios from 'axios'
    import config from "../../../config";

    export default {
        name: 'settlegrowers',
        data: function () {
            return {
                files: [],
                paginatedFiles: [],
                numberOfLinks: 0,
                numberOfItemsPerPage: 5,
                page: 1,
                currentPage: 0,
                search: '',

                permissions: []
            }
        },
        mounted () {
            this.getDataFromApi()

        },
        watch: {
            files: function () {
                this.paginatedFiles = this.files
                // this.numberOfLinks = Math.ceil(this.files.length / this.numberOfItemsPerPage)
            },
            page: function (val) {
                this.paginatedFiles = this.getUploadedFiles(val - 1)
            }
        },
        methods: {
          searchWarrants() {
      console.log('Item to',this.search)

      const url = config.serverURI +'/unbulked/search?query=' + this.search
      axios.get(url)
        .then(response => {
          console.log('Response',response.data.content)
          this.files = response.data.content
          this.totalWarrants = this.warrants.length
          this.numberOfLinks = response.data.page.totalPages
          this.numberOfItemsPerPage = response.data.page.size
          this.currentPage = response.data.page.number
        })
        .catch(error => {
          this.message = error.response?.status ?? 'Error occurred'
          this.snackbar = true
          this.snackbarColor = 'error'
        })
    },
          handleSearchInput() {
      if (this.search.trim() === '') {
        this.getDataFromApi(this.page-1);
      }else{
        console.log('Search Query')
        this.searchWarrants(); // Call search method on input
      }
    },
          approveAction (unbulked) {
      this.disableInteraction = true;
      const url = config.serverURI + '/eslip/approveChargePayment'
      console.log('calling ' + url)
      axios.post(url, unbulked)
        .then(response => {
          this.approveloading = false
          if (response.data.error !== false) {
            this.message = response.data.message
            this.snackbar = true
            this.snackbarColor = 'error'
            return
          }
          this.getDataFromApi()
          this.message = response.data.message
          this.snackbar = true
          this.snackbarColor = 'primary'
        })
        .catch(error => {
          console.log('error', error.response)
          this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
          this.snackbar = true
          this.snackbarColor = 'error'
          this.approveloading = false
        })
        .finally(() => {
          this.disableInteraction = false; // Re-enable interaction with the entire page
        });
      this.confirmDialog = false
    },
            getDataFromApi () {
                this.loading = true
                return new Promise((resolve, reject) => {
                    const items = this.getUploadedFiles(0)
                    const total = items.length
                    setTimeout(() => {
                        this.loading = false
                        resolve({
                            items,
                            total
                        })
                    }, 1000)
                })
            },
            async getPayments () {
      try {
        const response = await axios.get(config.serverURI + '/unbulked/getallbyeslipid/' + this.$route.params.eslipid)
        this.growerPayments = response.data
        console.log(this.growerPayments)
        this.totalWarrants = this.payments.length
        this.updatePagination()
      } catch (error) {
        this.handleRequestError(error, 'Error occurred while fetching payments')
      }
    },
    async getBrokerPayments () {
      console.log('Fetching broker payments...');
      try {
        const response = await axios.get(config.serverURI + '/brokerTransaction/getAllByUnbulkedId/' + this.$route.params.eslipid)
        this.brokerPayments = response.data
        console.log(this.brokerPayments)
        console.log('Length>>>',this.brokerPayments)
        // this.totalWarrants = this.brokerPayments.length
        this.updatePagination()
      } catch (error) {
        this.handleRequestError(error, 'Error occurred while fetching payments')
      }
    },
    async getMillerPayments () {
      console.log('Fetching broker payments...');
      try {
        const response = await axios.get(config.serverURI + '/millerTransaction/getAllByEslipId/' + this.$route.params.eslipid)
        this.millerPayments = response.data
        console.log(this.millerPayments)
        // this.totalWarrants = this.brokerPayments.length
        // this.updatePagination()
        this.numberOfLinks = Math.ceil(this.millerPayments.length / this.numberOfItemsPerPage)
        this.paginatedItems = this.paginationMethod(this.millerPayments, this.page, this.numberOfItemsPerPage)
      } catch (error) {
        this.handleRequestError(error, 'Error occurred while fetching payments')
      }
    },
    async getNcePayments () {
      try {
        const response = await axios.get(config.serverURI + '/nceTransaction/getAllByEslipId/' + this.$route.params.eslipid)
        this.ncePayments = response.data
        this.updatePagination()
      } catch (error) {
        this.handleRequestError(error, 'Error occurred while fetching payments')
      }
    },
    async getWarehousePaymentsByEslip () {
      try {
        const response = await axios.get(config.serverURI + '/warehouseTransaction/getAllByEslipId/' + this.$route.params.eslipid)
        this.warehousePayments = response.data
        console.log('Warehouse Transactions>>>',this.warehousePayments)
        this.updatePagination()
      } catch (error) {
        console.log('Error occurred while fetching payments ' + error)
      }
    },
    async getBuyerNcePaymentsByEslip () {
              try {
                  const response = await axios.get(config.serverURI + '/nceTransaction/getNceBuyerTransByEslipId/' + this.$route.params.eslipid)
                  this.nceBuyerPayment = response.data
                  console.log('NCE BUYER TRANSACTION',this.nceBuyerPayment)
                  this.updatePagination()
              } catch (error) {
                  console.log('Error occurred while fetching payments ' + error)
              }
          },
    async getInvoiceIds () {
      try {
        const response = await axios.get(config.serverURI + '/eslip/getInvoicesByEslipId/' + this.$route.params.eslipid)
        this.data = response.data
        this.totalWarrants = this.data.length
        this.updatePagination()
      } catch (error) {
        this.handleRequestError(error, 'Error occurred while fetching payments')
      }
    },
    async getallChargeTypes () {
      try {
        const response = await axios.get(config.serverURI + '/charges/getgrowerDeductions')
        this.chargetypes = response.data
        this.updatePagination()
      } catch (error) {
        this.handleRequestError(error, 'Error occurred while fetching chargetypes')
      }
    },
            canBeApproved (item) {
                return (item.status.id === 38 )
            },

            cleanFile (item) {
                return item.status.statusName === 'APPROVED'
            },

            canBeDeclined (item) {
                return item.status.id === 3 && this.hasPerm('CAN_APPROVE_PARCHMENT')
            },
            hasPerm (permission) {
                return this.permissions.includes(permission)
            },
            paginationMethod (items, pageNumber, limitPerPage) {
                pageNumber = pageNumber - 1
                const from = pageNumber * limitPerPage
                let to = (pageNumber + 1) * limitPerPage
                if (to >= items.length) {
                    to = items.length
                }
                return items.slice(from, to)
            },
            getUploadedFiles (page) {
                const url = config.serverURI + '/eslip/getGrowers?page=' + page + '&size=' + this.numberOfItemsPerPage + '&paginate=Y'
                axios.get(url)
                    .then(response => {
                        this.files = response.data.content
                        this.numberOfLinks = response.data.page.totalPages
                        this.numberOfItemsPerPage = response.data.page.size
                        this.currentPage = response.data.page.number
                        // this.files = response.data
                        this.$emit('updateparmentcount', response.data.page.totalElements)
                    })
                    .catch(error => {
                        // Request failed.
                        console.log('error', error.response)
                    })
                return this.files
            }
        }
    }
    </script>
    <style>
    .parrow_box {
      position: relative;
      background: #fff;
      border: 1px solid #707070;
      border-radius: 5px;
    }
    .parrow_box:after, .parrow_box:before {
      bottom: 100%;
      left: 18%;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    .parrow_box:after {
      border-color: rgba(255, 255, 255, 0);
      border-bottom-color: #fff;
      border-width: 20px;
      margin-left: -20px;
    }
    .parrow_box:before {
      border-color: rgba(112, 112, 112, 0);
      border-bottom-color: #707070;
      border-width: 21px;
      margin-left: -21px;
    }
    </style>
